import React from 'react'

import FieldDatetime from "../date-time"
import ErrorBoundary from "../../../../../error-boundary"
import HintPopover from "../../../../../gd-ui/hint-popover/hint-popover"

type FieldFormulaViewProps = {
    className?  : string

    field       : FieldDatetime
    model       : any

    options?    : any
    onClick?    : onClick
}

export default function FieldDatetime_ViewProperty(props: FieldFormulaViewProps) {
    const displayValue = props.field.getDisplayValue(props.field.getViewValue(props.model))

    const classes = Classes('ui5-property', props.className)

    return (
        <ErrorBoundary>
            <div className={classes}>
                <div className={Classes("ui5-ico-12 m-r-5", props.field.icon)}/>
                {displayValue}
                <HintPopover hint={props.field.label}/>
            </div>
        </ErrorBoundary>
    )
}
